import React, { useEffect, useState } from 'react'
import './Checkbox.scss'

const Checkbox = ({ label = '', value, onUpdate, isRequired, isDisabled }) => {
    const [_value, _setValue] = useState(value)

    useEffect(() => {
        _setValue(value)
    }, [value])

    const onChange = value => {
        if (!isDisabled) {
            _setValue(!_value)
            try {
                onUpdate(!_value)
            } catch (err) {
                console.error(err)
            }
        }
    }

    return (
        <div className={`common-checkbox ${isDisabled ? 'common-checkbox__disabled' : ''}`}>
            <div className="common-checkbox__content">
                <div
                    className={`common-checkbox__checkbox ${_value ? 'common-checkbox__checkbox-checked' : ''}`}
                    onClick={() => onChange()}
                />
                <p
                    className={`common-checkbox__label ${isRequired ? 'common-checkbox__required' : ''}`}
                    onClick={() => onChange()}
                >
                    {label.length ? label : null}
                </p>
            </div>
        </div>
    )
}

export default Checkbox
